import { render, staticRenderFns } from "./JKHome.vue?vue&type=template&id=4d205b92&scoped=true&"
import script from "./JKHome.vue?vue&type=script&lang=js&"
export * from "./JKHome.vue?vue&type=script&lang=js&"
import style0 from "./JKHome.vue?vue&type=style&index=0&id=4d205b92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d205b92",
  null
  
)

export default component.exports